export default {
  'menu.welcome': 'Benvenuto',
  'menu.more-blocks': 'Altri Blocchi',
  'menu.home': 'Home',
  'menu.console': 'Admin',
  'menu.console.sub-page': 'Sotto-Pagina',
  'menu.login': 'Accesso',
  'menu.register': 'Registrati',
  'menu.register-result': 'Risultato Registrazione',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analisi',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Posto di Lavoro',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Modulo',
  'menu.form.basic-form': 'Modulo Base',
  'menu.form.step-form': 'Modulo a Passi',
  'menu.form.step-form.info': 'Modulo a Passi(scrivi informazioni di trasferimento)',
  'menu.form.step-form.confirm': 'Modulo a Passi(conferma informazioni di trasferimento)',
  'menu.form.step-form.result': 'Modulo a Passi(completato)',
  'menu.form.advanced-form': 'Modulo Avanzato',
  'menu.list': 'Lista',
  'menu.list.table-list': 'Tabella di Ricerca',
  'menu.list.basic-list': 'Lista Base',
  'menu.list.card-list': 'Lista Schede',
  'menu.list.search-list': 'Lista di Ricerca',
  'menu.list.search-list.articles': 'Lista di Ricerca(articoli)',
  'menu.list.search-list.projects': 'Lista di Ricerca(progetti)',
  'menu.list.search-list.applications': 'Lista di Ricerca(applicazioni)',
  'menu.profile': 'Profilo',
  'menu.profile.basic': 'Profilo Base',
  'menu.profile.advanced': 'Profilo Avanzato',
  'menu.result': 'Risultato',
  'menu.result.success': 'Successo',
  'menu.result.fail': 'Fallimento',
  'menu.exception': 'Eccezione',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Innesca',
  'menu.account': 'Account',
  'menu.account.center': 'Centro Account',
  'menu.account.settings': 'Impostazioni Account',
  'menu.account.trigger': 'Innesca Errore',
  'menu.account.logout': 'Disconnetti',
  'menu.account.profile': 'Profilo',
  'menu.console.agents': 'agenti',
  'menu.console.agentDevice': 'dispositivoAgente',
  'menu.console.devices': 'dispositivi',
  'menu.console.speakers': 'Riconoscimento del parlante',
  'menu.console.voiceClone': 'Clonazione vocale',
  'menu.console.settings': 'Impostazioni personali',
  'menu.admin': 'Admin',
  'menu.admin.dashboard': 'Dashboard',
  'menu.admin.settings': 'Impostazioni',
  'menu.admin.providers': 'Fornitori di Modelli',
  'menu.admin.unbindDevice': 'Scollega Dispositivo',
  'menu.admin.userManage': 'Gestione Utenti',
  'menu.admin.systemConfig': 'Configurazione Sistema',
  'menu.admin.whiteList': 'Lista Bianca',
  'menu.admin.opsManage': 'Operazioni',
  'menu.admin.recorderManage': 'Gestione Registratore',
  'menu.admin.deviceManage': 'Gestione dispositivi',

  'menu.console.agentSetting': 'Impostazioni Agente',
};
